import { getQAFileTypeLabel } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { StartedQaAttempt } from '../types.ts';

type UploadedDocumentsInfoProps = { qaAttempt: StartedQaAttempt };

export function UploadedDocumentsInfo(props: UploadedDocumentsInfoProps) {
  const { qaAttempt } = props;

  return (
    <Flex flexDirection="column" gap="8px">
      <Typography>You uploaded the following documents to QC:</Typography>
      <ul style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <li>
          <Typography variant="h4">{getQAFileTypeLabel('reportPDF')}</Typography>
          <Typography>{qaAttempt.files.reportPDF.filename}</Typography>
        </li>
        <li>
          <Typography variant="h4">{getQAFileTypeLabel('orderDetailsPDF')}</Typography>
          <Typography>
            {qaAttempt.files.orderDetailsPDF?.filename ?? 'No document provided'}
          </Typography>
        </li>
        <li>
          <Typography variant="h4">{getQAFileTypeLabel('loePDF')}</Typography>
          <Typography>{qaAttempt.files.loePDF?.filename ?? 'No document provided'}</Typography>
        </li>
        <li>
          <Typography variant="h4">{getQAFileTypeLabel('purchaseContractPDF')}</Typography>
          <Typography>
            {qaAttempt.files.purchaseContractPDF?.filename ?? 'No document provided'}
          </Typography>
        </li>
      </ul>
    </Flex>
  );
}
